import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_TICKET](state, payload) {
    state.ticket = payload;
  },
  [MutationsType.SET_TICKETS](state, payload) {
    state.tickets = payload;
  },
  [MutationsType.SET_NEW_TICKETS](state, payload) {
    state.newTickets = payload;
  },
  [MutationsType.SET_TICKETS_BY_STATE](state, payload) {
    state.ticketsByState[payload.state_id] = payload;
  },
  [MutationsType.UPDATE_TICKETS_BY_STATE](state, payload) {
    const tickets = state.ticketsByState[payload.state_id].tickets;
    const ticketIndex = tickets.findIndex((t) => t.id === payload.ticket.id);
    if (ticketIndex >= 0)
      Vue.set(state.ticketsByState[payload.state_id].tickets, ticketIndex, {
        ...tickets[ticketIndex],
        ...payload.ticket,
      });
  },
  [MutationsType.REMOVE_TICKETS_BY_STATE](state) {
    state.ticketsByState = {};
  },
  [MutationsType.ADD_TICKET](state, payload) {
    state.tickets.push(payload);
  },
  [MutationsType.UPDATE_TICKET](state, payload) {
    let ind = (state.tickets || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.tickets, ind, payload.value || { ...state.tickets[ind], ...payload.add_value });
  },
  [MutationsType.REMOVE_TICKET](state, payload) {
    let ind = (state.newTickets || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.newTickets, ind);

    ind = (state.tickets || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.tickets, ind);
  },
  [MutationsType.UNSUBSCRIBE_GET_ALL_NEW_TICKETS](state, payload) {
    state.unsubscribeAllNewTickets = payload;
  },
  [MutationsType.SHOW_TICKET_DETAIL](state, payload) {
    state.ticketId = payload;
    state.showTicketDetailDrawer = !state.showTicketDetailDrawer;
  },
  [MutationsType.SHOW_TICKET_DETAIL_SECTION](state, payload) {
    state.showTicketDetailDrawerSection = payload;
  },
  [MutationsType.HIDE_TICKET_DETAIL](state) {
    state.ticketId = null;
    state.showTicketDetailDrawer = false;
  },
  [MutationsType.UNSUBSCRIBE_GET_TICKET](state) {
    state.unsubscribeGetTicket = null;
  },
  [MutationsType.SET_TICKET_DOWNLOADS](state, payload) {
    state.ticketsDownloads = payload;
  },
  [MutationsType.ADD_TICKET_DOWNLOAD](state, payload) {
    if (!state.ticketsDownloads.some((item) => item.id === payload.id)) {
      state.ticketsDownloads.unshift(payload);
    }
  },
  [MutationsType.UPDATE_TICKET_DOWNLOAD](state, payload) {
    let ind = (state.ticketsDownloads || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.ticketsDownloads, ind, { ...state.ticketsDownloads[ind], ...payload.data });
  },
  [MutationsType.REMOVE_TICKET_DOWNLOAD](state, payload) {
    let ind = state.ticketsDownloads.findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.ticketsDownloads, ind);
  },
};
